import { IAdobeAnalyticsConfig } from "./models/adobe-analytics.model";

export const adobeConfig: IAdobeAnalyticsConfig = {
    // isDevMode: true,
    clientDomain: "screenforepiincp.com",
    developmentSource: "//assets.adobedtm.com/acb96670c057/31fbd82ca9ee/launch-e1209d05f350-development.min.js",
    productionSource: "//assets.adobedtm.com/acb96670c057/31fbd82ca9ee/launch-46b4037bbe69.min.js",
    defaultPageLoadData: {
        pageInfo: {
            domain: "screenforepiincp.com",
            subDomain: "",
            url: window.location.href,
            path: window.location.pathname + window.location.hash,
            pageName: "Homepage",
            title: "",
            prefix: "screenforepiincp"
        },
        category: {
            primaryCategory: "homepage",
            subCategory1: "",
            subCategory2: ""
        },
        attributes: {
            country: "us",
            language: "en-us",
            template: "",
            promoMatsNumber: "ABBV-US-00951-MC",
            globalISI: "",
            type: "Homepage"
        },
        journey: {
            content: "Homepage",
            patient: "",
            messageBucket: "Medical Affairs"
        },
        product: {
            name: "",
            franchise: "Gastroenterology (Gastro)",
            indication: "Exocrine pancreatic insufficiency (EPI)",
            division: "Gastrointestinal Care",
            brand: ""
        },
        site: {
            type: "unbranded",
            experience: "medical affairs",
            audience: "health care professional (hcp)"
        },
        modal: {
            type: "",
            name: "",
            position: "",
            enabled: "",
            displayed: ""
        },
        search: {
            autoPosition: "",
            term: "",
            count: "",
            type: "",
            filterType: "",
            filterValue: "",
            filterCategory: "",
            sortByInit: "",
            origin: "",
            originURL: ""
        }
    },
    defaultUserData: [
        {
            profile: [
                {
                    id: {
                        crmID: "",
                        transID: "",
                        abbvieCustomerID: "",
                        hcpAccountID: "",
                        npiID: "",
                        dmpID: "",
                        adobeID: ""
                    },
                    attributes: {
                        status: "",
                        type: ""
                    }
                }
            ]
        }
    ]
};
